import React, { useEffect, useState, Suspense, lazy, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
const UpsellPopup = lazy(() => import('./components/UpsellPopup').then(m => ({
  default: m.UpsellPopup
})));
// Lazy load below-fold sections - reduces initial JS bundle significantly
const FrecuenciaSection = lazy(() => import('./components/FrecuenciaSection').then(m => ({
  default: m.FrecuenciaSection
})));
const CienciaSection = lazy(() => import('./components/CienciaSection').then(m => ({
  default: m.CienciaSection
})));
const TestimoniosSection = lazy(() => import('./components/TestimoniosSection').then(m => ({
  default: m.TestimoniosSection
})));
const IdentitySection = lazy(() => import('./components/IdentitySection').then(m => ({
  default: m.IdentitySection
})));
const ProtocoloSection = lazy(() => import('./components/ProtocoloSection').then(m => ({
  default: m.ProtocoloSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SalesNotification = lazy(() => import('./components/SalesNotification').then(m => ({
  default: m.SalesNotification
})));
export function App() {
  const [isUpsellOpen, setIsUpsellOpen] = useState(false);
  useEffect(() => {
    // Preconnect to critical origins for faster resource loading
    const preconnects = [{
      href: 'https://cdn.shopify.com',
      crossOrigin: 'anonymous'
    }, {
      href: 'https://fonts.gstatic.com',
      crossOrigin: 'anonymous'
    }];
    preconnects.forEach(({
      href,
      crossOrigin
    }) => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      if (crossOrigin) link.crossOrigin = crossOrigin;
      document.head.appendChild(link);
    });
    // Load Google Fonts via JS to break critical request chain
    // (moved from CSS @import which created: HTML→CSS→Fonts CSS→WOFF2 chain)
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700;800;900&display=swap';
    fontLink.media = 'print';
    fontLink.onload = function () {
      fontLink.media = 'all';
    };
    document.head.appendChild(fontLink);
    // Preload LCP image for early discovery
    const preloadLink = document.createElement('link');
    preloadLink.rel = 'preload';
    preloadLink.as = 'image';
    preloadLink.href = 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=280';
    preloadLink.setAttribute('fetchpriority', 'high');
    preloadLink.setAttribute('imagesrcset', 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=280 280w, ' + 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=350 350w, ' + 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/baby-365-7424892.png?v=1775591799&width=450 450w');
    preloadLink.setAttribute('imagesizes', '(max-width: 640px) 280px, (max-width: 1024px) 350px, 450px');
    document.head.appendChild(preloadLink);
    // Meta Pixel - load immediately for accurate tracking
    try {
      if (!(window as any).fbq) {
        const f = window as any;
        const n = f.fbq = function (...args: any[]) {
          if (n.callMethod) {
            n.callMethod.apply(n, args);
          } else {
            n.queue.push(args);
          }
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [] as any[];
        const t = document.createElement('script');
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const s = document.getElementsByTagName('script')[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          document.head.appendChild(t);
        }
      }
      ;
      (window as any).fbq('init', '919180517627113');
      (window as any).fbq('track', 'PageView');
      (window as any).fbq('track', 'ViewContent', {
        content_name: 'EL CÓDIGO 888 - Sistema de Programación Neuro-Cuántica',
        content_ids: ['51934295621934'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    } catch (e) {
      console.warn('Facebook Pixel failed to load:', e);
    }
    // Noscript fallback for pixel
    const noscriptImg = document.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = 'https://www.facebook.com/tr?id=919180517627113&ev=PageView&noscript=1';
    document.body.appendChild(noscriptImg);
  }, []);
  const handlePurchase = () => {
    setIsUpsellOpen(true);
  };
  return <div className="min-h-screen bg-dark font-sans text-white selection:bg-gold/30 selection:text-gold overflow-x-hidden w-full" data-id="element-0">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[99999] focus:bg-gold focus:text-dark focus:px-4 focus:py-2 focus:rounded focus:font-bold" data-id="element-1">
        Saltar al contenido principal
      </a>
      <Navbar handlePurchase={handlePurchase} data-id="element-2" />
      <main id="main-content" className="overflow-x-hidden" data-id="element-3">
        <HeroSection handlePurchase={handlePurchase} data-id="element-4" />
        <Suspense fallback={<div className="min-h-[50vh] bg-dark" data-id="element-6" />} data-id="element-5">
          <FrecuenciaSection data-id="element-7" />
          <CienciaSection data-id="element-8" />
          <TestimoniosSection data-id="element-9" />
          <ProtocoloSection handlePurchase={handlePurchase} data-id="element-10" />
          <IdentitySection handlePurchase={handlePurchase} data-id="element-11" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-12">
        <Footer data-id="element-13" />
        <SalesNotification data-id="element-14" />
      </Suspense>
      <Suspense fallback={null} data-id="element-15">
        <UpsellPopup isOpen={isUpsellOpen} onClose={() => setIsUpsellOpen(false)} data-id="element-16" />
      </Suspense>
    </div>;
}